import { cn } from "@/lib/utils";
import { NavLink } from "react-router";

interface MainNavItemProps extends React.HTMLAttributes<HTMLAnchorElement> {
    to: string;
    active?: boolean;
    onClick?: () => void | undefined;
    title?: string;
    target?: string;
}

const MainNavComponentItem: React.FC<MainNavItemProps> = ({
    className,
    target,
    onClick,
    active = true,
    title,
    to
}) => {
    return (
        <NavLink to={to} onClick={onClick ? onClick : undefined} target={target} className={cn(`flex items-center justify-between group ${active ? 'text-white' : 'text-sand'}`, className)}>
            <span className="group-hover:text-teal transition">{title}</span>
        </NavLink>

    );
}

export { MainNavComponentItem };